import { Context } from "effect";
export class StripeKeyResolver extends Context.Tag("@open-revenue/stripe/storage/StripeKeyResolver")() {
}
